import { trackError } from '@billy/track-error'
import pick from 'lodash/pick'

export const getLocalStorageFiltersValidated = <T extends object>(
  objectToCompare: T,
  value: string | null,
): T | undefined => {
  if (!value) {
    return undefined
  }

  try {
    return pick(JSON.parse(value), Object.keys(objectToCompare)) as T
  } catch (error) {
    trackError(error)
    return undefined
  }
}
